import { useLoaderData, type LoaderFunctionArgs } from "react-router";
import { canEditSurveys } from "@/lib/surveys/survey-service";
import type { SurveyRecord } from "@/lib/surveys/types";
import { SurveyEditor } from "@/components/surveys/survey-editor";
import { load } from "../api/load";
import { seg } from "../api/respond";
import { useAdmin } from "../session";

export function loader({ params }: LoaderFunctionArgs) {
  return load<SurveyRecord>(`/api/v1/admin/surveys/${seg(params.id!)}`);
}

export default function SurveyPage() {
  const survey = useLoaderData() as SurveyRecord;
  const auth = useAdmin();
  // Keyed on updatedAt so a saved survey resets the editor's local state.
  return <SurveyEditor key={survey.updatedAt} survey={survey} canEdit={canEditSurveys(auth.role)} />;
}
